//@flow
import { urlsConstants } from './../_constants/urls.constant';
import { defaultService } from './defaultService';

export const estoqueMovimentacaoService = {
  findAll,
  doGet,
  findByFiltro,
};

function findAll() {
  return defaultService.doGet(`${urlsConstants.ESTOQUE_MOVIMENTACAO}findAll`);
}

function doGet(id) {
  return defaultService.doGet(`${urlsConstants.ESTOQUE_MOVIMENTACAO}${id}`);
}

function findByFiltro(options: Options, filter: any): Promise<Array<>> {
  return defaultService.findByFiltro(
    `${urlsConstants.ESTOQUE_MOVIMENTACAO}list`,
    options,
    filter
  );
}
